<template>
  <div
    class="relative flex flex-col space-y-1"
    :class="{ 'pointer-events-none': disabled }"
    v-click-outside="closeList"
  >
    <label :for="name" v-if="label" class="text-sm">
      {{ label }}
    </label>

    <div
      class="relative flex items-center"
      :class="[
        {
          'cursor-pointer': !acceptInput,
        },
        { 'overflow-hidden rounded shadow': icon },
      ]"
      role="select"
      @click="toggleCollapse(acceptInput)"
    >
      <div v-if="icon" class="flex h-full items-center justify-center px-2" :class="iconStyles">
        <i v-html="icon"></i>
      </div>
      <input
        type="text"
        :class="[{ 'pointer-events-none': !acceptInput }, inputStyles]"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="$emit('input', { prop: name, value: $event.target.value })"
        @focus="fnFocus(value)"
        @blur="$emit('blur')"
        v-money="currency && money"
        autocomplete="off"
      />
      <button class="pointer-events-none absolute right-2 rotate-90 transform" v-if="options.length">
        <i v-html="$icons.chevron_right"></i>
        <span class="sr-only"> Expandir opções </span>
      </button>
    </div>
    <span v-if="showNoOptionsAlert && !options.length && value.length >= 3" class="text-ontick-orange-600 text-xs">
      Nenhuma opção disponível
    </span>
    <span v-else-if="forceSelect && !hasSelectedFromList && showForceSelectError" class="text-ontick-red-600 text-xs">
      Selecione um item da lista
    </span>

    <transition name="dropdown">
      <ul
        v-if="!isCollapsed && options.length"
        class="border-ontick-steel-500 dark:bg-ontick-graphite-500 absolute top-12 z-50 max-h-64 w-full overflow-auto rounded border bg-gray-200 text-sm shadow-lg"
      >
        <li v-for="(result, index) in filteredList" :key="result.value + index">
          <button class="hover:bg-ontick-steel-400 w-full py-2 px-2 text-left" @click="select(result.value)">
            <span v-if="currency">
              {{ result.value | currency }}
            </span>
            <span v-else>
              {{ result.label }}
            </span>
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { VMoney } from "v-money";

export default {
  directives: {
    ClickOutside,
    money: VMoney,
  },

  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    options: {
      type: Array,
    },
    acceptInput: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecione",
    },
    currency: {
      type: Boolean,
      default: false,
    },
    inputStyles: {
      type: String,
      default:
        "border-ontick-steel-300 dark:bg-ontick-carbon-500 dark:disabled:bg-ontick-steel-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border dark:border-0 dark:disabled:text-gray-500",
    },
    icon: {
      type: String,
    },
    iconStyles: {
      type: String,
      default: "bg-ontick-graphite-500",
    },
    forceSelect: {
      type: Boolean,
    },
    showForceSelectError: {
      type: Boolean,
    },
    showNoOptionsAlert: {
      type: Boolean,
    },
  },

  data() {
    return {
      isCollapsed: true,
    };
  },

  computed: {
    filteredList() {
      if (this.value && this.acceptInput) {
        const filtered = this.options.filter((item) => item.label.toUpperCase().includes(this.value.toUpperCase()));

        return filtered;
      } else {
        return this.options;
      }
    },
    hasSelectedFromList() {
      return this.filteredList.findIndex((item) => item.value === this.value) !== -1;
    },
  },

  methods: {
    toggleCollapse(acceptInput) {
      if (!acceptInput) {
        this.isCollapsed = !this.isCollapsed;
      }
    },
    closeList() {
      this.isCollapsed = true;
      this.$emit("close");
    },
    select(value) {
      this.isCollapsed = true;
      this.$emit("input", {
        prop: this.name,
        value: this.options.find((item) => item.value === value).label,
      });
      this.$emit("selected-from-box", value);
    },
    fnFocus(value) {
      this.isCollapsed = false;
      this.$emit("clear_field", { cacheField: value });
    },
  },

  watch: {
    input: {
      handler(val) {
        this.$emit("input", { prop: this.name, value: val });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  &-enter-active,
  &-leave-active {
    @apply transition-all;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply -translate-y-1/2 scale-y-0 opacity-0;
  }
}
</style>
